export enum CurrencyConversionStatus {
    Pending = 'pending',
    Scheduled = 'scheduled',
    Overdue = 'overdue',
    Settled = 'settled',
    Cancelled = 'cancelled',
    Blocked = 'blocked',
    InProgress = 'in-progress',
}
